import Select from 'react-select';
import { InputGroup, Container, InputsContainer } from './styles';
import search from '../../../../../assets/images/icons/search.svg';
import Input from '../../../../../components/Input';
import useThemeContext from '../../../../../contexts/theme';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../../../components/CustomSelectStyleDarkTheme';
import { ChangeEvent } from 'react';

interface FiltersInterface {
  searchNameTerm: string;
  handleChangeSearchNameTerm: (event: ChangeEvent<HTMLInputElement>) => void;
  searchCpfTerm: string;
  handleChangeSearchCpfTerm: (event: ChangeEvent<HTMLInputElement>) => void;
  searchConsultTerm: string;
  handleChangeSearchConsultTerm: (event: ChangeEvent<HTMLInputElement>) => void;
  selectedGoingLine: { value: string, label: string };
  handleChangeSelectedGoingLine: (line: { value: string, label: string }) => void;
  selectedBackLine: { value: string, label: string };
  handleChangeSelectedBackLine: (line: { value: string, label: string }) => void;
  selectedStatus: { value: string, label: string };
  handleChangeSelectedStatus: (status: { value: string, label: string }) => void;
  goingLineOptions: { value: string, label: string }[];
  backLineOptions: { value: string, label: string }[];
  statusOptions: { value: string, label: string }[];
}

export default function Filters({
  searchNameTerm,
  handleChangeSearchNameTerm,
  searchCpfTerm,
  handleChangeSearchCpfTerm,
  searchConsultTerm,
  handleChangeSearchConsultTerm,
  selectedGoingLine,
  handleChangeSelectedGoingLine,
  selectedBackLine,
  handleChangeSelectedBackLine,
  selectedStatus,
  handleChangeSelectedStatus,
  goingLineOptions,
  backLineOptions,
  statusOptions,
}: FiltersInterface) {
  const { selectedTheme } = useThemeContext();

  return (
    <Container>
      <header>
        <img src={search} alt="search" />
        Pesquise através dos filtros abaixo
      </header>
      <InputsContainer>
        <InputGroup>
          <span>Nome</span>
          <Input
            placeholder="Nome"
            value={searchNameTerm}
            onChange={handleChangeSearchNameTerm}
          />
        </InputGroup>
        <InputGroup>
          <span>CPF</span>
          <Input
            placeholder="CPF (somente números)"
            value={searchCpfTerm}
            onChange={handleChangeSearchCpfTerm}
          />
        </InputGroup>
        <InputGroup>
          <span>Consulta</span>
          <Input
            placeholder="Consulta"
            value={searchConsultTerm}
            onChange={handleChangeSearchConsultTerm}
          />
        </InputGroup>
        <InputGroup>
          <span>Linha ida</span>
          <Select
            value={selectedGoingLine.value ? selectedGoingLine : { value: '', label: 'Selecione uma linha '}}
            options={goingLineOptions}
            onChange={(goingLine) => handleChangeSelectedGoingLine(goingLine as { value: string, label: string })}
            placeholder="Filtrar por linha ida"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        </InputGroup>
        <InputGroup>
          <span>Linha volta</span>
          <Select
            value={selectedBackLine.value ? selectedBackLine : { value: '', label: 'Selecione uma linha '}}
            options={backLineOptions}
            onChange={(backLine) => handleChangeSelectedBackLine(backLine as { value: string, label: string })}
            placeholder="Filtrar por linha volta"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        </InputGroup>
        <InputGroup>
          <span>Status</span>
          <Select
            value={selectedStatus}
            options={statusOptions}
            onChange={(status) => handleChangeSelectedStatus(status as { value: string, label: string })}
            placeholder="Filtrar por linha volta"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        </InputGroup>
      </InputsContainer>
    </Container>
  );
}
